import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    state => state.partnerMap
)

export const selectStoreGeo = createSelector(
    baseSelector,
    (state) => state.storeGeo
)
export const selectStoreGeoLoading = createSelector(
    baseSelector,
    (state) => state.isStoreGeoLoading
)
export const selectStoreGeoFirstLoad = createSelector(
    baseSelector,
    (state) => state.isStoreGeoFirstLoad
)
export const selectStoreGeoError = createSelector(
    baseSelector,
    (state) => state.storeGeoError
)
export const selectStoreStatistics = createSelector(
    baseSelector,
    (state) => state.storeStatistics
)
export const selectStoreStatisticsLoading = createSelector(
    baseSelector,
    (state) => state.isStoreStatisticsLoading
)
export const selectStoreStatisticsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isStoreStatisticsFirstLoad
)
export const selectCurrentPartner = createSelector(
    baseSelector,
    (state) => state.selectedPartner
)
export const selectStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)
export const selectEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)
export const selectCurrentStore = createSelector(
    baseSelector,
    (state) => state.selectedStore
)
export const selectInspectStoreModalOpen = createSelector(
    baseSelector,
    (state) => state.isInspectStoreModalOpen
)
